import { Component, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { Interval } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';

import { SceneService } from '../../services/scene.service';

const RESOURCE_POLL_INTERVAL = 500;

@Component({
  selector: 'scene-debugger',
  templateUrl: './scene-debugger.component.html',
  styleUrls: ['./scene-debugger.component.scss'],
  standalone: false,
})
export class SceneDebuggerComponent extends Loggable implements OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);
  private pollInterval?: Interval;

  public groups: Record<string, unknown>[] = [];
  public playersInView: string[] = [];

  public constructor(private sceneService: SceneService) {
    super();
    this.setDisplayName('SceneDebuggerComponent');

    this.pollInterval = setInterval(this.pollResources.bind(this), RESOURCE_POLL_INTERVAL);
  }

  public ngOnDestroy(): void {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private pollResources(): void {
    this.playersInView = this.sceneService.getPlayersIds();
    this.groups = this.sceneService.getGroups();
  }
}
